import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=7f670456&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b2bDigital/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports